export default "__VITE_ASSET__DGa4A9qq__"